import { FormikContextType } from "formik";
import { TServiceValuationForm } from "./types";

const resetServiceHolder = (
  formikContext: FormikContextType<TServiceValuationForm>
) => {
  formikContext.setValues({
    ...formikContext.values,

    service_holder_op: "new",
    service_holder_id: "",
    Usuarios_a_cuidar: "1",
    Unidad_de_convivencia: "",
    Direccion: "",
    Direccion_2: "",
    Ciudad: null,
    Codigo_postal: "",
    Region: null,
    Area: null,
    Latitud: undefined,
    Longitud: undefined,
    formatted_address: undefined,

    Nombre_U1: "",
    Primer_apellido_U1: "",
    Segundo_apellido_U1: "",
    Fecha_de_nacimiento_U1: null,
    DNI_U1: "",

    Patologias_U1: [],
    Comentarios_patologias_U1: "",
    Medicacion_U1: "",
    Dieta: "",
    Habla_expresion_U1: "",
    Peso_U1: "",
    Altura_U1: "",
    Movilidad_U1: [],

    Estado_emocional_y_caracter_U1: [],
    Adaptaci_n_de_cuidados_U1: "",
    Comentarios_estado_emocional_y_caracter_U1: "",
    Actividades_y_aficiones_U1: "",
    Calidad_del_sue_o_U1: null,
    Aseo_U1: [],
    Indicaciones_del_sueno_U1: "",
    Indicaciones_del_aseo_U1: "",

    Nombre_U2: "",
    Primer_apellido_U2: "",
    Segundo_apellido_U2: "",
    Fecha_de_nacimiento_U2: null,
    DNI_U2: "",

    Patologias_U2: [],
    Comentarios_patologias_U2: "",
    Medicacion_U2: "",
    Dieta_U2: "",
    Habla_expresion_U2: "",
    Peso_U2: "",
    Altura_U2: "",
    Movilidad_U2: [],

    Estado_emocional_y_caracter_U2: [],
    Adaptaci_n_de_cuidados_U2: "",
    Comentarios_estado_emocional_y_caracter_U2: "",
    Actividades_y_aficiones_U2: "",
    Calidad_del_sue_o_U2: null,
    Aseo_U2: [],
    Indicaciones_del_sueno_U2: "",
    Indicaciones_del_aseo_U2: "",

    Tipo_de_vivienda: "",
    home_elevator: false,
    home_adapted_bathroom: false,
    home_crane: false,
    home_cameras: false,
    home_articulated_bed: false,
    home_pets: false,
    home_clean_service: false,
    home_tele_asistance: false,
    Proveedor_de_Teleasistencia: "",
    Comunicacion_con_transporte_publico: "",

    Notas_coordinadora: "",
  });
};

export { resetServiceHolder };
